import React from 'react';
import { LFC } from '../../Legacy';
import { Button, Prompt } from '../../ui';
import { useResolve } from '../Container';
import { BoardUsageModel } from '../account/BoardUsageModel';
import { Copy } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { UpgradeButton } from '../upgrade/UpgradeButton';

export const boardLimitExceededPopup = () => ({ ui: BoardLimitExceededPopup, args: {} });

export const BoardLimitExceededPopup: LFC<PopupProps> = ({ action, dismiss }) => {
    const { limit } = useResolve(BoardUsageModel);
    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup w={36}>
            <Popup.Close onAction={dismiss} />
            <Popup.Title>Active Board Limit Exceeded</Popup.Title>
            <Popup.Content>
                <Copy>
                    <p>Sorry, your team is over its active board limit.</p>
                    <p>Teams on the Free Plan are limited to 4 active boards. This board is now View Only.</p>
                    <p>To reactivate this board, either delete some of your active boards or upgrade to a premium plan for unlimited boards.</p>
                </Copy>
            </Popup.Content>
            <Popup.Actions>
                <UpgradeButton />
                <Button onAction={dismiss}>Close</Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
